import { createContext } from "react";

export const ResumeInfoContext = createContext();
